import { createTheme, ThemeProvider, CssBaseline } from '@mui/material';
import { useState, useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Header from './components/Header';
import Footer from './components/Footer';
import ProductCtms from './pages/ProductCtms';
import ProductInsightRm from './pages/ProductInsightRm';
import ProductInformer from './pages/ProductInformer';
import NewsAndEvents from './pages/NewsAndEvents';
import ClinicalTrial from './pages/ClinicalTrialManagement';
import ProfessionalServices from './pages/ProfessionalServices';
import IntrinsicBiophy from './pages/IntrinsicBiophy';
import RequestDemo from './pages/RequestDemo';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Articles from './pages/NewsAndEvents/Articles';
import Videos from './pages/NewsAndEvents/WebinarsCards';
import Contact from './pages/contact';
import Conferences from './pages/NewsAndEvents/Conferences';
import ArticleDetails from './pages/NewsAndEvents/ArticleDetails';
import Leadership from './pages/Leadership';
import AboutSection from './pages/AboutSection';
import CareersPage from './pages/CareersPage';
import Faq from './pages/Faq';



function App() {
  const [isDarkMode, setIsDarkMode] = useState(false);

  const theme = useMemo(() => createTheme({
    palette: {
      mode: isDarkMode ? 'dark' : 'light',
      primary: {
        main: '#03a9f4',
      },
      background: {
        default: isDarkMode ? '#121212' : '#f5f5f5',
        paper: isDarkMode ? '#1e1e1e' : '#fff',
      },
      text: {
        primary: isDarkMode ? '#ffffff' : '#333333',
      },
    },
    typography: {
      fontFamily: 'Roboto, sans-serif',
    },
  }), [isDarkMode]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Header toggleDarkMode={() => setIsDarkMode(!isDarkMode)} isDarkMode={isDarkMode} />
        <main style={{ minHeight: '80vh', padding: '1rem' }}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/ctms" element={<ProductCtms />} />
            <Route path="/insights-rm" element={<ProductInsightRm />} />
            <Route path="/informer" element={<ProductInformer />} />
            <Route path="/news-events" element={<NewsAndEvents />} />
            <Route path="/clinical-trial" element={<ClinicalTrial />} />
            <Route path="/Professional-Services" element={<ProfessionalServices />} />
            <Route path="/intrinsic-biophy" element={<IntrinsicBiophy />} />
            <Route path="/request-demo" element={<RequestDemo />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/articles" element={<Articles />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/conference" element={<Conferences />} />
            <Route path="/article/:id" element={<ArticleDetails />} />
            <Route path="/about" element={<About />} />
            <Route path="/leadership" element={<Leadership />} />
            <Route path="/about-section" element={<AboutSection />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/faq" element={<Faq />} />
            {/* Add other routes as needed */}
          </Routes>
        </main>
        <Footer />
      </Router>
    </ThemeProvider>
  );
}

export default App;



